import classes from "./PillButton.module.scss";

const PillButton = ({ type = "button", children, onClick, disabled, className }) => {
  return (
    <button
      type={type}
      className={`${classes.pillButton} ${className} ${disabled ? classes.disabled : ""}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default PillButton;
